import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
} from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  BulletinType,
  ResendBulletinInput,
} from 'services/interfaces/installation/bulletin';
import { useBulletinContext } from '../BulletinContext';
import { resendDateError } from './resendDateError';

interface BulletinResendModalProps {
  isOpen: boolean;
  onClose(): void;
}

const BulletinResendModal: React.FC<BulletinResendModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { loading, handleResend } = useBulletinContext();

  const [type, setType] = useState<BulletinType>('DAILY');
  const [date, setDate] = useState('');

  const today = moment().format('YYYY-MM-DD');
  const dateError = resendDateError(date, type);

  useEffect(() => {
    if (isOpen) {
      setType('DAILY');
      setDate(today);
    }
  }, [isOpen, today]);

  const onSubmit = () => {
    if (dateError) return;

    const payload: ResendBulletinInput = {
      data: date,
      type,
    };
    handleResend(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={!loading}
      closeOnEsc={!loading}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton isDisabled={loading} />
        <ModalHeader>Reenviar boletim</ModalHeader>

        <ModalBody as={Stack} gap="1rem">
          <FormControl isRequired>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Tipo
            </FormLabel>
            <Select
              isDisabled={loading}
              value={type}
              onChange={(e) => setType(e.target.value as BulletinType)}
            >
              <option value="DAILY">Diário</option>
              <option value="WEEKLY">Semanal</option>
            </Select>
          </FormControl>

          <FormControl isRequired isInvalid={!!dateError}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Data
            </FormLabel>
            <Input
              type="date"
              max={today}
              isDisabled={loading}
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            {dateError && <FormErrorMessage>{dateError}</FormErrorMessage>}
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr="3" onClick={onClose} isDisabled={loading}>
            Cancelar
          </Button>
          <Button
            colorScheme="yooga"
            isLoading={loading}
            isDisabled={!!dateError}
            onClick={onSubmit}
          >
            Reenviar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BulletinResendModal;
